import { Verified } from '@mui/icons-material';
import {
  Box,
  BoxProps,
  Card,
  CardContent,
  Typography,
  colors,
  styled,
} from '@mui/material';
import React from 'react';

const bankLogos = [
  '001',
  '002',
  '003',
  '004',
  '006',
  '010',
  '016',
  '219',
  '320',
  '328',
  '374',
  '540',
  '612',
  '614',
  '621',
  '815',
  '837',
  '869',
];

interface Props extends BoxProps {
  name: string;
  bank?: string;
  number: string;
  transit: string;
  institute: string;
  verified?: boolean;
}

const MuiCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: 6,
  boxShadow: '0 10px 25px 0 #3c425714, 0 5px 10px 0 #0000001f',
  border: '4px dashed #3c425714',
  backgroundColor: theme.palette.grey[100],

  '& .MuiCardContent-root': {
    padding: '0!important',
  },

  '& .title': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(0.5),

    '& .verified': {
      display: 'flex',
      alignItems: 'center',
      marginLeft: theme.spacing(1),
      '& .MuiTypography-root': {
        fontSize: 12,
        color: '#3AB54A',
      },
    },
  },

  '& .chequeTitle': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),

    '& .MuiTypography-root': {
      fontWeight: 700,
      fontSize: 20,
      color: theme.palette.grey[700],
    },

    '& > *': {
      width: 'fit-content',
      wordBreak: 'break-all',
    },
  },

  '& .chequeLogo': {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    justifyContent: 'flex-end',
    textAlign: 'right',

    '& img': {
      maxHeight: 35,
    },
  },

  '& .chequeDetails': {
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    marginTop: theme.spacing(3),
    fontFamily: 'MICR Encoding',
    fontSize: 24,
    lineHeight: 1,

    '& .chequeNum': {
      color: theme.palette.grey[600],
      textAlign: 'center',

      '& > span': {
        fontFamily: theme.typography.fontFamily,
        display: 'block',
        fontSize: 10,
      },
    },
  },
}));

const Cheque: React.FC<Props> = ({
  name,
  bank,
  number,
  transit,
  institute,
  verified,
  ...props
}) => {
  const [noLogo, setNoLogo] = React.useState(false);
  const [logoSrc, setLogoSrc] = React.useState('');

  React.useEffect(() => {
    // Check for institute in bankLogos
    const logo = bankLogos.find((bankLogo) => bankLogo === institute);
    if (logo) {
      setLogoSrc(`/images/banks/${logo}.svg`);
      setNoLogo(false);
    } else {
      setLogoSrc('/images/banks/other.svg');
      setNoLogo(true);
    }
  }, [institute]);

  return (
    <Box {...props}>
      <MuiCard>
        <CardContent>
          <Box className="chequeTitle">
            <div className="title">
              {name && <Typography>{name}</Typography>}
              {verified && (
                <div className="verified">
                  <Typography>(Verified</Typography>
                  <Verified
                    sx={{ ml: 0.5 }}
                    htmlColor="#3AB54A"
                    fontSize="small"
                  />
                  <Typography>)</Typography>
                </div>
              )}
            </div>
            {institute.length >= 3 && (
              <Box className="chequeLogo">
                {noLogo && <Typography fontSize={12}>{bank}</Typography>}
                <img width={40} src={logoSrc} alt={name} />
              </Box>
            )}
          </Box>
          <Box className="chequeDetails">
            <div className="chequeNum">
              c000c
              <span>cheque #</span>
            </div>
            <div>a{transit}</div>
            <div>d{institute}a</div>
            <div>{number}c</div>
          </Box>
        </CardContent>
      </MuiCard>
    </Box>
  );
};

export default Cheque;
